import React from "react";

type BlockComponentProps = {
  titre?: string;
  children: React.ReactNode;
  reverse?: boolean;
  card?: boolean;
  centered?: boolean;
  custom?: boolean;
};

const BlockComponent: React.FC<BlockComponentProps> = ({ titre, children, reverse, centered, card, custom }) => {
  if (custom)
    return (
      <div
        className={`flex ${reverse ? "md:flex-row-reverse" : "md:flex-row"} ${
          card && "large-card"
        } flex-col items-center justify-center gap-8 text-whiteAccent`}
      >
        {children}
      </div>
    );
  else
    return (
      <div
        className={`flex ${reverse ? "md:flex-row-reverse" : "md:flex-row"} ${
          card && "large-card"
        } w-full flex-col items-center justify-center gap-8 text-whiteAccent`}
      >
        <div className={`flex flex-col ${centered ? "items-center" : "items-start "} ${card && "card"} w-full`}>
          {titre && <h2 className="text-left font-bold uppercase">{titre}</h2>}
          <div className={`w-full text-lg text-whiteAccent/80 ${centered ? "text-center" : "text-left"} flex flex-col gap-y-14`}>{children}</div>
        </div>
      </div>
    );
};

export default BlockComponent;
